module.exports = __webpack_public_path__ + "static/Washington_Crossing_the_Delaware-6bb9839104b8d66308d4edcf059c3d30.jpg";